import { jsx as _jsx } from "react/jsx-runtime";
var Video = function Video(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 14.5996L17.191 11.9996L20 9.40063V14.5996ZM15 15.9996C15 16.5516 14.552 16.9996 14 16.9996H5C4.448 16.9996 4 16.5516 4 15.9996V7.99963C4 7.44863 4.448 6.99963 5 6.99963H14C14.552 6.99963 15 7.44863 15 7.99963V15.9996ZM21.012 7.14563C20.386 6.87263 19.66 6.99163 19.161 7.45163L17 9.45163V7.99963C17 6.34563 15.654 4.99963 14 4.99963H5C3.346 4.99963 2 6.34563 2 7.99963V15.9996C2 17.6546 3.346 18.9996 5 18.9996H14C15.654 18.9996 17 17.6546 17 15.9996V14.5486L19.161 16.5476C19.481 16.8446 19.896 16.9996 20.319 16.9996C20.553 16.9996 20.788 16.9526 21.012 16.8546C21.621 16.5886 22 16.0196 22 15.3706V8.62963C22 7.98063 21.621 7.41163 21.012 7.14563Z",
      fill: color
    })
  });
};
export default Video;